import * as React from "react"
import { Skeleton } from "@mui/material"
import { AppTableSeeker } from "@components"

import { GROUPED_BY } from "@constants"
import { groupedBy } from "@signals"
import { useSkuDetailsPricingData } from "./@hooks"
import SkuDetailsPricingTableActions from "./Actions"
import { countryColumn, priceColumn, retailerColumn } from "./columns"
import { useSkuDetailsRoleConfig } from "../@hooks"
import { selectedCountryPricing, selectedMarketplacePricing } from "../@signals"


export default function SkuDetailsPricingTable() {
	
	const { isStandardUser } = useSkuDetailsRoleConfig()
	const { isLoadingPricing, data, handleChangeGroupBy } = useSkuDetailsPricingData()

	if (isLoadingPricing) return <Skeleton variant="rectangular" height={300} />
    if (!data?.length) return <></>

	return <AppTableSeeker
		title={'Pricing Market Analyzer'}
		data={data}
		columns={[
            ...countryColumn(),
            ...(groupedBy.value.includes(GROUPED_BY.RETAILER) ? [retailerColumn()] : []),
			priceColumn(isStandardUser ? 'rrsp' : 'myPrice', isStandardUser ? 'RRSP' : 'My Price'),
			priceColumn('minPrice', 'Min Price'),
			priceColumn('maxPrice', 'Max Price'),
			priceColumn('avgPrice', 'Avg Price')
		]}
		options={{
			rowsPerPage: 5,
			rowsPerPageOptions: [5, 10],
			tableBodyHeight: '440px',
			customToolbar: () => {
				return <SkuDetailsPricingTableActions handleChangeGroupBy={handleChangeGroupBy} />
			}
		}}
	/>
}